/**
 * Chave de idempotência (uuid v4) para um POST que move dinheiro.
 *
 * O `crypto.randomUUID()` só existe em contexto seguro (https ou localhost); o painel aberto
 * por IP em http não o tem. Nesse caso o uuid sai do `crypto.getRandomValues()`, que existe
 * em qualquer contexto — nunca do `Math.random()`, que não serve para chave que o backend usa
 * para deduplicar.
 */
export function newIdempotencyKey(source: Crypto = globalThis.crypto): string {
  if (typeof source.randomUUID === 'function') {
    return source.randomUUID();
  }

  const bytes = source.getRandomValues(new Uint8Array(16));
  // Versão 4 e variante RFC 4122.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
